
      // For local development only - this won't affect production builds
      if (typeof globalThis.__fw_env__ === 'string') {
        globalThis.__fw_env__ = {
          FW_ENV: import.meta.env.FW_ENV,
          FW_BASE_URL: import.meta.env.FW_BASE_URL,
          FW_BASE_API_URL: import.meta.env.FW_BASE_API_URL,
          FW_AUTH_URL: import.meta.env.FW_AUTH_URL,
          FW_HASURA_API_URL: import.meta.env.FW_HASURA_API_URL,
          FW_SHOP_RENDERER_API_URL: import.meta.env.FW_SHOP_RENDERER_API_URL,
          FW_HERO_URL: import.meta.env.FW_HERO_URL,
          FW_MY_SHOP_URL: import.meta.env.FW_MY_SHOP_URL,
          FW_UPSCALER_URL: import.meta.env.FW_UPSCALER_URL,
        }
      }
    